import { CalendarLayoutActionEnum } from '@api/ringil-api.v2';

/**
 * The assignment actions. Re-exported under short names because they read better at the call sites
 * that build target lists, and because these two are the only members that exist.
 */
export const ASSIGN = CalendarLayoutActionEnum.ASSIGN;
export const REMOVE = CalendarLayoutActionEnum.REMOVE;
